import { OpaqueToken } from '@angular/core';

export const VALIDATION_MESSAGE_MAPPER = new OpaqueToken('validationMessageMapper');

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
